import React, { createContext, useContext } from 'react';
import useOnboardingState from '../../hooks/useOnboardingState';

const OnboardingContext = createContext(null);

export function OnboardingProvider({ children }) {
  const onboarding = useOnboardingState();
  return (
    <OnboardingContext.Provider value={onboarding}>
      {children}
    </OnboardingContext.Provider>
  );
}

export function useOnboarding() {
  const ctx = useContext(OnboardingContext);
  if (!ctx) throw new Error('useOnboarding must be used within OnboardingProvider');
  return ctx;
}
